import { Col, Row, Modal, Form, message } from "antd";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import Title from "../UI/Title/Title";
import { CountInterface } from "./Interfaces";
import { closeCount } from "../../api/inventoryCount";

type prop = {
    isCloseCountOpen: boolean;
    setIsCloseCountOpen: React.Dispatch<React.SetStateAction<boolean>>;
    itemToClose: {
        name: string,
        id: number
    };

    setCounts: React.Dispatch<React.SetStateAction<CountInterface[]>>;
    setCountsSearch: React.Dispatch<React.SetStateAction<CountInterface[]>>;
    counts: CountInterface[];
    countsSearch: CountInterface[];
    setIsLocked: React.Dispatch<React.SetStateAction<boolean>>;
};

const CloseCount = ({
    isCloseCountOpen,
    setIsCloseCountOpen,
    itemToClose,
    setCounts,
    setCountsSearch,
    counts,
    countsSearch,
    setIsLocked }: prop) => {

    const [t] = useTranslation("common");

    const { mutateAsync: closeCountMutation, isLoading } = useMutation(
        "closeCount",
        ({ id }: { id: number }) =>
            closeCount({ id }),
        {
            onSuccess: ({ data }) => {
                setCounts(counts.map((item: CountInterface) => {
                    if (item.id === itemToClose.id) {
                        const { message, ...updatedItem } = data;
                        return updatedItem;
                    }
                    return item;
                }));
                setCountsSearch(countsSearch.map((item: CountInterface) => {
                    if (item.id === itemToClose.id) {
                        const { message, ...updatedItem } = data;
                        return updatedItem;
                    }
                    return item;
                }));
                message.success(data.message)
                setIsLocked(true)
                setIsCloseCountOpen(false)
            },
            onError: ({ response }) => {
                message.error(response.data.message)
            }
        }
    );

    const handleSubmit = () => {
        closeCountMutation({ id: itemToClose.id })
    }

    return (
        <>
            <Modal
                centered
                okText={`${t("confirm")}`}
                open={isCloseCountOpen}
                width={490}
                onCancel={() => setIsCloseCountOpen(false)}
                closable={false}
                maskClosable={false}
                cancelText={`${t("cancel")}`}
                okButtonProps={{
                    style: {
                        height: "40px",
                        background: "#1677FF",
                        color: "#fff",
                        width: "100px",
                    },
                    loading: isLoading
                }}
                cancelButtonProps={{
                    style: {
                        color: "#1677FF",
                        border: "1px solid #1677FF",
                        height: "40px",
                        width: "100px",
                    },
                }}
                onOk={handleSubmit}
                destroyOnClose
            >
                <Form layout="vertical">
                    <Row>
                        <Col span={24}>
                            <Title title={`${t("confirm-closure")}`} />
                        </Col>
                        <br />
                        <br />
                        <Col span={24} className="modaltitleEdit">{`${t(
                            "please-confirm-closing"
                        )} 
                        ${itemToClose.name}`}</Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
};

export default CloseCount;
